import { NewsletterView } from "../models/newsletterview.model";
import { responseHero } from "../utils/axiosInterceptor";

export type PickedNewsLetterViewerVideos =
    Pick<NewsletterView, "videoId" | "subject" | "videoName" | "newsLetterId" | "user">

export const getNewsLetterVideos = (): Promise<PickedNewsLetterViewerVideos[]> => {
    return new Promise<PickedNewsLetterViewerVideos[]>((resolve, reject) => {
        
        responseHero.get(`${process.env.REACT_APP_API_URL}/videoids`).then((response) => {
            resolve(response.data as PickedNewsLetterViewerVideos[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};